import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MessageTempView = () => {
    const { state } = useLocation();
    const { templateDetails } = state || {};

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center">
                <h3>TEMPLATE DETAILS: {templateDetails.name}</h3><Link to="/message-templates" className="btn btn-dark btn-sm">BACK</Link>
            </div>

            <table className="table table-bordered table-striped table-hover">
                <thead class="table table-dark">
                    <tr>
                        <th>PROPERTY</th>
                        <th>VALUE</th>
                    </tr>
                </thead>
                <tbody>
                    <tr><td><strong>Category</strong></td><td>{templateDetails.category}</td></tr>
                    <tr><td><strong>Sub Category</strong></td><td>{templateDetails.sub_category}</td></tr>
                    <tr> <td><strong>Status</strong></td><td style={{ color: templateDetails.status === 'approve' ? 'red' : 'green' }}>{templateDetails.status}</td></tr>
                    <tr><td><strong>Language</strong></td><td>{templateDetails.language}</td></tr>
                </tbody>
            </table>

            <h5 style={{ color: '#333', fontSize: '1.25rem', marginBottom: '10px' }}>COMPONENTS</h5>
            {templateDetails.components && templateDetails.components.length > 0 ? (
                <table className="table table-bordered table-striped table-hover">
                    <thead className="table table-dark">
                        <tr>
                            <th>Type</th>
                            <th>Format</th>
                            <th>Text</th>
                            <th>Image</th>
                            <th>Buttons</th>
                        </tr>
                    </thead>
                    <tbody>
                        {templateDetails.components.map((component, idx) => (
                            <tr key={idx}>
                                <td>{component.type}</td>
                                <td>{component.format ? component.format : ''}</td>
                                <td>{component.text ? component.text : ''}</td>
                                <td>
                                    {component.example && component.example.header_handle && component.example.header_handle.length > 0 ? (
                                        (() => {
                                            const mediaUrl = component.example.header_handle[0];
                                            const format = component.format?.toUpperCase();

                                            switch (format) {
                                                case 'IMAGE':
                                                    return <img src={mediaUrl} alt="Header Example" style={{ width: '100px', height: 'auto' }} />;

                                                case 'VIDEO':
                                                    return (
                                                        <video width="200" height="auto" controls>
                                                            <source src={mediaUrl} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    );

                                                case 'DOCUMENT':
                                                    return (
                                                        <a href={mediaUrl} target="_blank" rel="noopener noreferrer">
                                                            View PDF Document
                                                        </a>
                                                    );

                                                case 'LOCATION':
                                                    // For map, assume mediaUrl is like "latitude,longitude"
                                                    const [lat, lng] = mediaUrl.split(',');
                                                    const mapUrl = `https://www.google.com/maps?q=${lat},${lng}&z=15&output=embed`;
                                                    return (
                                                        <iframe
                                                            title="Location Map"
                                                            src={mapUrl}
                                                            width="200"
                                                            height="150"
                                                            style={{ border: 0 }}
                                                            allowFullScreen=""
                                                            loading="lazy"
                                                        ></iframe>
                                                    );

                                                default:
                                                    return <span>Unsupported media type</span>;
                                            }
                                        })()
                                    ) : ''}
                                </td>

                                <td>
                                    {component.buttons && component.buttons.length > 0 ? (
                                        <ul>
                                            {component.buttons.map((button, buttonIdx) => (
                                                <li key={buttonIdx}>
                                                    <strong>Button Text:</strong> {button.text}<br />
                                                    <strong>Flow ID:</strong> {button.flow_id}<br />
                                                    <strong>Flow Action:</strong> {button.flow_action}<br />
                                                    {button.navigate_screen && <strong>Navigate to Screen:</strong>} {button.navigate_screen}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No components available.</p>
            )}
        </div>
    );
};

export default MessageTempView;
